import { useNavigate, useLocation } from 'react-router-dom';
import { Compass, Film, Wrench } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: React.ElementType;
  path: string;
}

const tabs: Tab[] = [
  {
    id: 'alignment',
    label: 'Alignment',
    icon: Compass,
    path: '/dashboard/growth',
  },
  {
    id: 'library',
    label: 'Library',
    icon: Film,
    path: '/dashboard/library',
  },
  {
    id: 'tools',
    label: 'Tools',
    icon: Wrench,
    path: '/dashboard/tools',
  },
];

export default function TabNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    if (location.pathname.includes('/dashboard/growth')) return 'alignment';
    if (location.pathname.includes('/dashboard/library')) return 'library';
    if (location.pathname.includes('/dashboard/tools')) return 'tools';
    return 'alignment';
  };

  const activeTab = getActiveTab();

  return (
    <div className="mt-6 bg-white rounded-lg shadow-md overflow-hidden">
      <div className="grid grid-cols-3 divide-x divide-gray-200">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`
                relative flex flex-col items-center justify-center gap-1 py-2.5 px-3
                transition-all duration-200 group
                ${
                  isActive
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-blue-600'
                }
              `}
            >
              {isActive && (
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-blue-600" />
              )}

              <Icon
                size={20}
                className={`
                  transition-all duration-200
                  ${isActive ? 'scale-105' : 'group-hover:scale-105'}
                `}
              />

              <span className={`
                text-xs font-medium
                ${isActive ? 'font-semibold' : ''}
              `}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
